import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Text18 } from '../../../ui/Text18';
import TouristsModal from './TouristsModal';
import { InsuranceParameters, SetInsuranceParameters, IInsurance, SetInsurance } from '../../../types';
import { InputWrapper, InputTitle, TuristsSelector, TouristWrapper } from '../style';

type Props = {
  insurance: IInsurance; 
  setInsurance: SetInsurance;
  insuranceParameters?: InsuranceParameters;
  setInsuranceParameters?: SetInsuranceParameters;  
};

const TouristsSelect: React.FC<Props> = ({
  insurance,
  setInsurance,
  insuranceParameters,
  setInsuranceParameters,  
}) => {
  const { t } = useTranslation();
  const { modalsVisibility } = insuranceParameters;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleVisibility = (params: any) => {
    if (params.target.id !== 'delete-icon') {
      const modalType = params.target.id;
      setInsuranceParameters({
        ...insuranceParameters,
        modalsVisibility: {
          ...modalsVisibility,
          [modalType]: true,
        },
      });
    }
    setAnchorEl(params.currentTarget);
  };  

  return (
    <InputWrapper>
      <InputTitle>{t('who_to_go')}</InputTitle>
      <TuristsSelector
        id='tourists'
        onClick={handleVisibility}
        isActive={modalsVisibility.tourists}
      >
        <TouristWrapper>
          <Text18>{`${t('who_to_go')} - ${insurance.beneficiary.length}`}</Text18>
        </TouristWrapper>
      </TuristsSelector>
      {modalsVisibility.tourists && (
        <TouristsModal
          insurance={insurance}
          setInsurance={setInsurance}
          insuranceParameters={insuranceParameters}
          setInsuranceParameters={setInsuranceParameters}         
          anchorEl={anchorEl}
        />
      )}
    </InputWrapper>
  );
};

export default TouristsSelect;
